// react
import React from 'react'
// antd
import {Empty, EmptyProps} from 'antd'
// img
import EmptyImg from '@/assets/img/empty.png'

/**
 * 空状态组件
 * @constructor
 */
const EmptyPanel = (props: EmptyProps) => {
  return <Empty
    className={"p-[24px]"}
    image={
      <img alt={""} className={"mr-[10px]"} src={EmptyImg}/>
    }
    {...props}
  />
}

export default EmptyPanel
